import { FormParagraph } from '@ksyos/design-system';
import type { IJournal } from '@common/validation/episodesAndJournal';
import { JournalEntryType } from '@common/enums/journalEntryType';
import { FormLabel } from '@frontend/components/elements/forms';
import { HorizontalFormGroup } from '../../elements/forms/HorizontalFormGroup';
import { HorizontalFormGroupRead } from '../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../elements/forms/InputContainer';

interface IJournalEntriesReadProps {
    journalEntries: IJournal[];
}

export function JournalEntriesRead({ journalEntries }: IJournalEntriesReadProps) {
    return journalEntries.map((jounalEntry) => {
        return (
            <HorizontalFormGroupRead key={jounalEntry.episodeValueDisplayName}>
                <FormLabel>Journaalregels van {jounalEntry.episodeValueDisplayName}</FormLabel>

                <HorizontalFormGroup>
                    <InputContainer className="ml-5">
                        <FormParagraph>
                            {`Subjectief: ${
                                jounalEntry[JournalEntryType.Subjectief]
                                    ? jounalEntry[JournalEntryType.Subjectief]
                                    : '-'
                            }`}
                        </FormParagraph>
                        <FormParagraph>
                            {`Objectief: ${
                                jounalEntry[JournalEntryType.Objectief] ? jounalEntry[JournalEntryType.Objectief] : '-'
                            }`}
                        </FormParagraph>
                        <FormParagraph>
                            {`Evaluatie: ${
                                jounalEntry[JournalEntryType.Evaluatie] ? jounalEntry[JournalEntryType.Evaluatie] : '-'
                            }`}
                        </FormParagraph>
                        <FormParagraph>
                            {`Plan: ${jounalEntry[JournalEntryType.Plan] ? jounalEntry[JournalEntryType.Plan] : '-'}`}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroup>
            </HorizontalFormGroupRead>
        );
    });
}
